import { useState, useEffect } from "react";
import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/testimonials/approved`);
        setTestimonials(data);
      } catch {}
    })();
  }, []);

  if (testimonials.length === 0) return null;

  return (
    <section className="py-24 bg-[#0F172A]" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16">
          <p className="text-[10px] font-semibold tracking-[0.25em] uppercase text-[#D4A373] mb-4">Kundenstimmen</p>
          <h2 className="font-['Playfair_Display'] text-3xl lg:text-4xl font-semibold text-white mb-4">
            Was unsere Kunden sagen
          </h2>
          <p className="text-[#94A3B8] max-w-lg text-[15px] leading-relaxed">
            Echte Erfahrungen von Unternehmen, die mit LAB336 ihre Prozesse transformiert haben.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="bg-[#1E293B]/50 border border-white/5 p-6 flex flex-col"
              data-testid={`testimonial-card-${t.id}`}
            >
              {/* Quote */}
              <Quote className="w-6 h-6 text-[#D4A373] mb-4 opacity-40" />

              {/* Text */}
              <p className="text-[#CBD5E1] text-[15px] leading-relaxed flex-1 mb-6">
                "{t.text}"
              </p>

              {/* Rating */}
              <div className="flex gap-0.5 mb-4">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className={`w-3.5 h-3.5 ${n <= t.rating ? "fill-[#D4A373] text-[#D4A373]" : "text-[#334155]"}`} />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                {t.photo_url ? (
                  <img src={t.photo_url} alt={t.client_name} className="w-10 h-10 rounded-full object-cover" />
                ) : (
                  <div className="w-10 h-10 rounded-full bg-[#D4A373]/10 flex items-center justify-center text-[#D4A373] font-semibold text-sm">
                    {t.client_name?.charAt(0)?.toUpperCase()}
                  </div>
                )}
                <div>
                  <p className="text-white text-sm font-medium">{t.client_name}</p>
                  <p className="text-[#64748B] text-xs">{[t.position, t.company].filter(Boolean).join(", ") || ""}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
